console.debug(`VUE_APP_ISCACHE: ${process.env.VUE_APP_ISCACHE}`)
// const isCache = process.env.VUE_APP_ISCACHE === 'true' ? true : false
const BASEURL_DOMAIN = process.env.VUE_APP_APIURL_WORLDCUP
const BASEURL_API = process.env.VUE_APP_APIURL_API

function computedBaseUrl(baseApi) {
  // 不同开发环境，不同接口根目录，导致域名不同
  let baseUrl = ''
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_API === 'development'
  ) {
    // 本地开发
    return baseApi
  }
  if (baseApi.indexOf('/api') === 0) {
    baseUrl = BASEURL_API
  } else {
    baseUrl = BASEURL_DOMAIN
  }
  return baseUrl + baseApi
}

// league 接口 start ---------

// 获取赛季 接口
export const https_basketball_seasonList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/cmp/findseasoninfos/${params.cid}`)
  )
}

// 获取赛程当前日期和球队列表 接口
export const https_schedule_matchDateAndTeamList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/schedule/getScheduleDateAndTeam`),
    params
  )
}

// 获取某天的一周日期 接口
export const https_schedule_weekList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/schedule/getDaysByDate?date=${params.date}`)
  )
}

// 获取某天的赛程列表 接口
export const https_schedule_matchList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/schedule/getScheduleMatch`),
    params
  )
}

// 获取单场比赛基本详情 接口
export const https_schedule_matchDetail = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/schedule/getMatchInfo`), params)
}

// 查询某场比赛 节次 接口
export const https_matchDetail_sectionList = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/cmp/matchList/121`), params)
}

// 赛果中数据统计 table 数据 接口
export const https_matchDetail_teamStatData = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/getMatchStats/${params.sid}/${params.mid}/${params.phid}`
    )
  )
}

// 获取赛果详情 - 投篮热区中的选择框 接口
export const https_teamDetail_hotspotsSelectList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/hotSpot/filter/${params.sid}/${params.mid}`
    )
  )
}

// 获取赛果详情 - 投篮热区 接口
export const https_teamDetail_hotspotsData = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/schedule/hotSpot/data`), params)
}

// 获取球队详情基本信息 接口
export const https_teamDetail_baseInfor = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/team/getTeamBasicData`), params)
}

// 获取球队详情 - 球员名单 接口
export const https_teamDetail_playerList = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/team/getTeamsPlayer`), params)
}

// 获取球队参赛赛季列表 接口
export const https_teamDetail_seasonList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/team/getTeamJoinedSeason`),
    params
  )
}

// 获取球队详情 - 球队数据 - 赛季数据 接口
export const https_teamDetail_seasonStatList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/team/getTeamStatsOfSeason`),
    params
  )
}

// 获取球队详情 - 球队数据 - 主客队 接口
export const https_teamDetail_homeawaystat = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/team/getTeamStatsOfPlace`),
    params
  )
}

// 获取球队详情 - 球队数据 - 胜负 接口
export const https_teamDetail_winloststat = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/team/getTeamStatsOfWinOrLoss`),
    params
  )
}

// 获取球队详情 - 球队数据 - 对阵球队 接口
export const https_teamDetail_againststat = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/team/getTeamStatsOfBattle`),
    params
  )
}

// 获取球队详情 - 比赛统计 接口
export const https_teamDetail_matchstat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/team/ms/matchstat/${params.cid}/${params.phid}/${params.tid}?asc=${params.asc}&sid=${params.sid}&sort=${params.sort}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 获取球队详情 - 球队赛程 接口
export const https_teamDetail_teamSchedule = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/team/getScheduleByMatch`),
    params
  )
}

// 获取球队排名 赛季列表 接口
export const https_basketball_teamRankSeasonList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/standing/getSeasonByComId`),
    params
  )
}

// 获取球队排名列表 接口
export const https_teamRankList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/standing/getStandingRank`),
    params
  )
}

// 获取球员位置列表 接口
export const https_positionNameList = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/player/index/pos/infos`))
}

// 获取球员列表 接口
export const https_playerList = (baseUrl, axios, params) => {
  console.debug('https_playerList:', params)
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/index/base/infos/${params.sid}?tid=${params.tid}&pcode=${params.pcode}&pname=${params.pname}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 获取球员参赛赛季列表 接口
export const https_playerDetail_seasonList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/cd/joined/seasons/${params.cid}/${params.pid}`
    )
  )
}

// 获取球员详情基本信息 接口
export const https_playerDetail_baseInfor = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/cd/latest/playerstat/${params.cid}/${params.pid}`
    )
  )
}

// 球员 - 综合数据 - 赛季数据 接口
export const https_playerDetail_seasonStatList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/cd/season/basicplayerstat/${params.sid}/${params.phid}/${params.tid}/${params.pid}?stat=${params.stat}`
    )
  )
}

// 球员 - 综合数据 - 主客队 接口
export const https_playerDetail_homeawaystat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/cd/season/homeawaystat/${params.sid}/${params.phid}/${params.tid}/${params.pid}?stat=${params.stat}&sort=${params.sort}&asc=${params.asc}`
    )
  )
}

// 球员 - 综合数据 - 胜负 接口
export const https_playerDetail_winloststat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/cd/season/winloststat/${params.sid}/${params.phid}/${params.tid}/${params.pid}?stat=${params.stat}&sort=${params.sort}&asc=${params.asc}`
    )
  )
}

// 球员 - 综合数据 - 对阵球队 接口
export const https_playerDetail_againststat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/cd/season/againststat/${params.sid}/${params.phid}/${params.tid}/${params.pid}?stat=${params.stat}&sort=${params.sort}&asc=${params.asc}`
    )
  )
}

// 球员 - 生涯数据 接口
export const https_playerDetail_careerData = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/cr/playerstat/${params.cid}/${params.phid}/${params.pid}?stat=${params.stat}`
    )
  )
}

// 球员 - 比赛统计 接口
export const https_playerDetail_matchstat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/ms/matchstat/${params.cid}/${params.phid}/${params.pid}?asc=${params.asc}&sid=${params.sid}&sort=${params.sort}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 数据中心-数据概览
export const https_package_getDataOverviewByType = (baseUrl, axios, params) => {
  //templateType： 22:球队数据；20:球员是数据
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/dataoverview/getDataOverviewByType/${params.templateType}/${params.cid}/${params.sid}`
    )
  )
}

// 数据中心-球队数据
export const https_record_teamStatList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/dc/team/stat/${params.sid}/${params.phid}?stat=${params.stat}&sort=${params.sort}&asc=${params.asc}`
    )
  )
}

// 数据中心-球员数据-基本数据
export const https_record_playerStatList_base = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/dc/player/basicstat/${params.sid}/${params.phid}?psp=${params.psp}&tid=${params.tid}&stat=${params.stat}&sort=${params.sort}&asc=${params.asc}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 数据中心-球员数据-基本数据
export const https_record_playerStatList_high = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/dc/player/advancestat/${params.sid}/${params.phid}?tid=${params.tid}&sort=${params.sort}&asc=${params.asc}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 数据中心-季后赛对阵
export const https_getKnockoutData = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/schedule/getKnockoutData/${params.sid}`)
  )
}

// league 接口 end ---------

// cup 接口 start ----------

// 赛段细分 接口
export const https_basketballCup_allstage = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/schedule/findallphase/${params.sid}`)
  )
}

// 赛程列表 接口
export const https_basketballCup_groupScheduleList = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findcupschedule/${params.cid}/${params.sid}?phase=${params.stage}`
    )
  )
}

// 积分榜数据 接口
export const https_basketballCup_leagueTable = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/standing/getCupStandingRank`),
    params
  )
}

// 淘汰赛 接口
export const https_basketballCup_knockoutData = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/schedule/getKnockoutData/${params.sid}`)
  )
}

// 根据赛季获取球队列表 接口
export const https_seasonCup_teamList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/team/findCupSeasonTeams`),
    params
  )
}

// 赛果出场名单 接口
export const https_scheduleDetail_startList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/schedule/getMatchLineup`),
    params
  )
}

// cup 接口 end ----------

// league && cup 共用 接口 start ----------

// 根据赛季获取球队列表 接口
export const https_season_teamList = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/team/findTeams`), params)
}

// cup 接口 end ----------

// 测试网络超时
export const https_server_timeOut = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`/testdemo/testdata`))
}
